import { Card, CardContent } from '@/components/ui/card';
import { ShieldCheckIcon, LockClosedIcon, UserIcon } from '@heroicons/react/24/outline';

const PrivacySection = () => {
  const features = [
    {
      icon: ShieldCheckIcon,
      title: "Secure & Encrypted",
      description: "Bank-level encryption protects all client data."
    },
    {
      icon: LockClosedIcon,
      title: "Strict No-Sale Policy", 
      description: "We never sell or rent client information to third parties."
    },
    {
      icon: UserIcon,
      title: "Clients Retain Full Data Ownership",
      description: "Clear privacy settings and transparent data controls at every level."
    }
  ];

  return (
    <div className="py-16 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-6">
            Built for Client Trust and Data Protection
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Your reputation depends on trust. SeniorThrive is designed to protect client data and maintain professional integrity.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {features.map((feature, index) => (
            <Card key={index} className="border-border/50 hover:border-primary/20 transition-colors">
              <CardContent className="p-8 text-center">
                <div className="w-16 h-16 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-6">
                  <feature.icon className="w-8 h-8 text-primary" />
                </div>
                <h3 className="text-xl font-semibold text-foreground mb-4">
                  {feature.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {feature.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrivacySection;
